import { borderRadius } from '#/common/hooks/useClientTheme';
import { color } from '@nuvolo/nuux-theme/utils';
import styled from 'styled-components';

const Styles = styled.div`
  .dx-widget.dx-textbox.dx-texteditor.dx-editor-outlined,
  .dx-htmleditor.dx-htmleditor-outlined {
    flex: 1;
    height: 44px;
    border-right-width: 0;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    border-top-left-radius: ${borderRadius?.s};
    border-bottom-left-radius: ${borderRadius?.s};
    box-shadow: none;
    border: 1px solid ${color('custom', 'formInputBorder')};

    input.dx-texteditor-input,
    textarea.dx-texteditor-input {
      font-size: 16px;
    }

    + .dx-widget.dx-button {
      height: 44px;
      box-shadow: none;
      border-top-left-radius: 0 !important;
      border-bottom-left-radius: 0 !important;
      margin: 0;
    }
  }
`;

export default Styles;
